export enum CustomerPortalVersion {
  V35 = "v3.5",
  V40 = "v4.0",
}
